import jsPDF from "jspdf";
import autoTable from "jspdf-autotable";
import { fmtBRL, fmtPct } from "./format";

const FLUA_BLUE = [30, 40, 185]; // RGB da paleta oficial

const monthLabel = (yyyyMm) => {
  if (!yyyyMm) return "Todos os meses";
  const [y, m] = yyyyMm.split("-");
  const meses = [
    "Janeiro", "Fevereiro", "Março", "Abril", "Maio", "Junho",
    "Julho", "Agosto", "Setembro", "Outubro", "Novembro", "Dezembro",
  ];
  return `${meses[parseInt(m, 10) - 1] || m}/${y}`;
};

/**
 * Gera um recibo de comissão em PDF para um vendedor.
 * vendedor: metric enriquecido com meta/bonus/comissao_total e lista .clientes
 */
export const gerarReciboPDF = ({ vendedor, month, bonusPct }) => {
  const doc = new jsPDF({ unit: "pt", format: "a4" });
  const pageWidth = doc.internal.pageSize.getWidth();

  // Header colorido
  doc.setFillColor(...FLUA_BLUE);
  doc.rect(0, 0, pageWidth, 90, "F");
  doc.setTextColor(255, 255, 255);
  doc.setFont("helvetica", "bold");
  doc.setFontSize(22);
  doc.text("FLUA", 40, 40);
  doc.setFontSize(11);
  doc.setFont("helvetica", "normal");
  doc.text("Recibo de comissão", 40, 58);
  doc.setFontSize(9);
  doc.text(
    `Emitido em ${new Date().toLocaleDateString("pt-BR")}`,
    pageWidth - 40,
    40,
    { align: "right" }
  );
  doc.text(`Período: ${monthLabel(month)}`, pageWidth - 40, 58, { align: "right" });

  // Vendedor info
  doc.setTextColor(30, 30, 30);
  doc.setFont("helvetica", "bold");
  doc.setFontSize(14);
  doc.text(vendedor.nome, 40, 130);
  doc.setFont("helvetica", "normal");
  doc.setFontSize(10);
  doc.setTextColor(90, 90, 90);
  doc.text(
    `${vendedor.vendas} venda(s) · Ticket médio ${fmtBRL(vendedor.ticket_medio)}`,
    40,
    148
  );

  // Tabela de vendas
  const rows = (vendedor.clientes || []).map((c) => [
    c.nome_cliente || "—",
    c.cpf || "—",
    c.plano_escolhido || "—",
    fmtBRL(c._price),
    fmtBRL(c._lucro || 0),
    fmtBRL(c._commission),
  ]);

  autoTable(doc, {
    head: [["Cliente", "CPF / CNPJ", "Plano", "Valor", "Lucro plano", "Comissão"]],
    body: rows,
    startY: 170,
    theme: "grid",
    styles: { font: "helvetica", fontSize: 9, cellPadding: 6 },
    headStyles: { fillColor: FLUA_BLUE, textColor: 255, fontStyle: "bold" },
    alternateRowStyles: { fillColor: [245, 245, 250] },
    columnStyles: {
      3: { halign: "right" },
      4: { halign: "right" },
      5: { halign: "right" },
    },
  });

  // Totais
  const finalY = doc.lastAutoTable ? doc.lastAutoTable.finalY : 200;
  const summaryY = finalY + 24;

  const drawRow = (y, label, value, bold = false, color = [30, 30, 30]) => {
    doc.setTextColor(...color);
    doc.setFont("helvetica", bold ? "bold" : "normal");
    doc.setFontSize(10);
    doc.text(label, pageWidth - 260, y);
    doc.text(value, pageWidth - 40, y, { align: "right" });
  };

  drawRow(summaryY, "Receita bruta", fmtBRL(vendedor.receita));
  drawRow(summaryY + 18, "Lucro bruto (planos)", fmtBRL(vendedor.lucro_bruto || 0));
  drawRow(summaryY + 36, `Comissão base (${fmtPct((vendedor.comissao_pct || 0) * 100)})`, fmtBRL(vendedor.comissao));
  const bonusLine = vendedor.bateu_meta
    ? `Bônus por meta atingida (+${fmtPct((bonusPct || 0) * 100)})`
    : "Bônus por meta (não atingida)";
  drawRow(summaryY + 54, bonusLine, fmtBRL(vendedor.bonus));

  // linha divisória
  doc.setDrawColor(...FLUA_BLUE);
  doc.setLineWidth(1);
  doc.line(pageWidth - 260, summaryY + 66, pageWidth - 40, summaryY + 66);
  drawRow(summaryY + 84, "Total a receber", fmtBRL(vendedor.comissao_total), true, FLUA_BLUE);

  // Rodapé
  doc.setFontSize(8);
  doc.setTextColor(150, 150, 150);
  doc.text(
    "Documento gerado automaticamente pelo painel FLUA · Controle comercial de ponta a ponta",
    40,
    doc.internal.pageSize.getHeight() - 24
  );

  const safeName = (vendedor.nome || "vendedor").replace(/[^\w\-]/g, "_");
  doc.save(`recibo-${safeName}-${month || "geral"}.pdf`);
};
